import { useEffect, useRef, useState } from 'react'

/** Debounce edits and follow external value changes. */
export function useDebouncedInput(value: string, onChange: (value: string) => void) {
  const [inputValue, setInputValue] = useState(value)
  const debounceRef = useRef<ReturnType<typeof setTimeout>>(null)
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current)
    setInputValue((currentInput) => (currentInput.trim() === value ? currentInput : value))
  }, [value])

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => {
      const trimmed = inputValue.trim()
      if (trimmed !== value) {
        onChangeRef.current(trimmed)
      }
    }, 300)
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue])

  return { inputValue, setInputValue }
}
